module.exports = __webpack_public_path__ + "img/jiqixuexi.974ef05c.png";